import React from 'react';
import { FaEye, FaHandPointer, FaRobot } from 'react-icons/fa';
import { ALGO_MODES } from '../../../config/angelOne';

const MODES = [
  { key: ALGO_MODES.MANUAL, label: 'Manual', desc: 'View signals only', icon: FaEye, activeClass: 'bg-blue-50 border-blue-300 text-blue-700' },
  { key: ALGO_MODES.SEMI_AUTO, label: 'Semi-Auto', desc: 'Confirm before execute', icon: FaHandPointer, activeClass: 'bg-amber-50 border-amber-300 text-amber-700' },
  { key: ALGO_MODES.FULL_AUTO, label: 'Full Auto', desc: 'Auto-execute signals', icon: FaRobot, activeClass: 'bg-red-50 border-red-300 text-red-700' },
];

export default function ModeSelector({ mode, onChange }) {
  return (
    <div className="flex gap-2">
      {MODES.map(m => {
        const active = mode === m.key;
        const Icon = m.icon;
        return (
          <button
            key={m.key}
            onClick={() => onChange(m.key)}
            className={`flex-1 p-3 rounded-xl border transition-all text-left ${
              active ? m.activeClass : 'bg-white border-gray-200 hover:bg-gray-50 text-gray-500'
            }`}
          >
            <div className="flex items-center gap-2 mb-1">
              <Icon className="text-sm" />
              <span className={`text-sm font-medium ${active ? '' : 'text-gray-700'}`}>
                {m.label}
              </span>
            </div>
            <div className={`text-[10px] ${active ? 'opacity-70' : 'text-gray-400'}`}>{m.desc}</div>
          </button>
        );
      })}
    </div>
  );
}
